(function () {
  'use strict';

  var CTA_SELECTOR = '[data-designer-cta]';
  var STATUS_SELECTOR = '[data-pm-variant-status]';
  var READY_FLAG = '__pmDesignerCtaReady';
  var PENDING_TIMEOUT_MS = 10000;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function getProductRoot(button) {
    return button.closest('product-info') || button.closest('[data-section-id]') || document;
  }

  function findVariantInput(root) {
    var sectionId = root && root.dataset ? root.dataset.section : '';
    var form = sectionId ? root.querySelector('#product-form-' + sectionId) : null;
    form = form || root.querySelector('form[data-product-form]') || root.querySelector('form[action*="/cart/add"]');
    return form ? form.querySelector('input[name="id"]') : null;
  }

  function buildDesignerUrl(studioUrl, handle, variantId) {
    var url = new URL(studioUrl || '/pages/designer-studio', window.location.origin);
    url.searchParams.set('product', handle);
    if (variantId) url.searchParams.set('variant', variantId);
    return url.pathname + url.search + url.hash;
  }

  function navigate(href) {
    if (typeof window.__pmDesignerNavigate === 'function') window.__pmDesignerNavigate(href);
    else window.location.assign(href);
  }

  function recordDesignerOpen(handle) {
    if (window.PrintmoProductPageMetrics) window.PrintmoProductPageMetrics.emit('product_page_designer_open', { product_handle: handle });
  }

  function eventBelongsToRoot(root, payload) {
    var data = payload && payload.data;
    var eventTarget = data && data.event && data.event.target;
    if (eventTarget && root !== document) return root.contains(eventTarget);
    var sectionId = data && data.sectionId;
    return !sectionId || !root.dataset || String(sectionId) === String(root.dataset.section || root.dataset.sectionId || '');
  }

  function normalizedText(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function selectedOptionValues(root) {
    return Array.from(root.querySelectorAll('.product__selectors .selector-wrapper')).map(function (wrapper) {
      var checked = wrapper.querySelector('input:checked');
      if (checked && checked.value) return checked.value;
      var select = wrapper.querySelector('select');
      return select && select.selectedOptions && select.selectedOptions[0] ? select.selectedOptions[0].textContent.trim() : '';
    }).filter(Boolean);
  }

  function completedSelectionMessage(root, status) {
    var values = selectedOptionValues(root);
    var selection = values.length
      ? (status.dataset.selectionValuesTemplate || '__OPTIONS__ selected.').replace('__OPTIONS__', values.join(', '))
      : (status.dataset.selectionUpdated || 'Selection updated.');
    var priceLabel = normalizedText(root.querySelector('.product__pricing-label')) || 'Blank item price';
    var priceRoot = root.querySelector('[id^="Price-"]');
    var price = normalizedText(priceRoot && (
      priceRoot.querySelector('.price-item--sale.price-item--last')
      || priceRoot.querySelector('.price__regular .price-item--regular')
      || priceRoot.querySelector('.price-item--last')
    ));
    return price
      ? (status.dataset.selectionPriceTemplate || '__SELECTION__ __LABEL__ __PRICE__.')
        .replace('__SELECTION__', selection)
        .replace('__LABEL__', priceLabel)
        .replace('__PRICE__', price)
      : selection;
  }

  function initDesignerButton(button) {
    if (!button || button[READY_FLAG]) return;
    button[READY_FLAG] = true;

    var root = getProductRoot(button);
    var status = root.querySelector(STATUS_SELECTOR);
    var studioUrl = button.getAttribute('data-studio-url') || '/pages/designer-studio';
    var handle = button.getAttribute('data-product-handle') || root.getAttribute('data-product-handle') || '';
    var fallbackVariant = button.getAttribute('data-fallback-variant') || '';
    var input = findVariantInput(root);
    var failed = button.dataset.initialAvailable === 'false';
    var currentVariantId = failed ? '' : (input && input.value ? String(input.value) : fallbackVariant);
    var pending = false;
    var deferredNavigation = false;
    var pendingTimer = null;

    function setStatus(message) {
      if (status) {
        status.textContent = message || '';
        status.classList.toggle('visually-hidden', !failed);
      }
    }

    function setPending(nextPending) {
      pending = nextPending;
      button.toggleAttribute('aria-busy', pending);
      button.toggleAttribute('aria-disabled', pending || failed);
      if (pendingTimer) window.clearTimeout(pendingTimer);
      pendingTimer = null;
      if (pending) {
        failed = false;
        button.setAttribute('aria-disabled', 'true');
        setStatus(status?.dataset.pendingMessage || 'Updating selection…');
        pendingTimer = window.setTimeout(function () {
          pending = false;
          failed = true;
          currentVariantId = '';
          deferredNavigation = false;
          button.removeAttribute('aria-busy');
          button.setAttribute('aria-disabled', 'true');
          button.removeAttribute('href');
          setStatus(status?.dataset.timeoutMessage || "We couldn't update this selection. Choose the options again or try another color.");
        }, PENDING_TIMEOUT_MS);
      }
    }

    function updateHref() {
      if (pending || failed || !currentVariantId) {
        button.setAttribute('aria-disabled', 'true');
        if (!pending) button.removeAttribute('href');
        return '';
      }
      var href = buildDesignerUrl(studioUrl, handle, currentVariantId);
      button.setAttribute('href', href);
      button.removeAttribute('aria-disabled');
      return href;
    }

    function beginSelection(payload) {
      if (!document.documentElement.contains(root) || !eventBelongsToRoot(root, payload)) return;
      failed = false;
      setPending(true);
    }

    function completeSelection(payload) {
      if (!document.documentElement.contains(root) || !eventBelongsToRoot(root, payload)) return;
      var variant = payload && payload.data && payload.data.variant;
      var validVariant = Boolean(variant && variant.id && variant.available !== false);
      currentVariantId = validVariant ? String(variant.id) : '';
      failed = !validVariant;
      setPending(false);
      var href = updateHref();
      if (validVariant) setStatus(completedSelectionMessage(root, status || { dataset: {} }));
      else if (variant && variant.available === false) setStatus(status?.dataset.soldOutMessage || 'This size is out of stock. Choose another size or color.');
      else setStatus(status?.dataset.unavailableMessage || 'This option combination is unavailable. Choose another color or size.');
      if (deferredNavigation && href) {
        deferredNavigation = false;
        recordDesignerOpen(handle);
        navigate(href);
      }
    }

    if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, beginSelection);
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, completeSelection);
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      if (pending) {
        deferredNavigation = true;
        return;
      }
      if (failed) return;
      var liveInput = findVariantInput(root);
      if (liveInput && liveInput.value) currentVariantId = String(liveInput.value);
      var href = updateHref();
      if (href) {
        recordDesignerOpen(handle);
        navigate(href);
      }
    });

    updateHref();
  }

  function initDesignerCtas(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    if (target.matches && target.matches(CTA_SELECTOR)) initDesignerButton(target);
    target.querySelectorAll(CTA_SELECTOR).forEach(initDesignerButton);
  }

  document.addEventListener('theme:product-info:loaded', function (event) {
    initDesignerCtas(event.target);
  });

  ready(function () { initDesignerCtas(document); });
})();
